import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import httpService from '../../api/httpService';

function OrganizationDetail() {
    const { orgId } = useParams();
    const [loading, setLoading] = useState(true);
    const [organization, setOrganization] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const result = await httpService.getData(`/Organization/${orgId}`);
                if (result?.isSuccess && result?.retObject) {
                    setOrganization(result.retObject);
                } else {
                    setError(result?.message || 'Failed to load registry.');
                }
            } catch (err) {
                setError('Failed to load registry details.');
            } finally {
                setLoading(false);
            }
        };
        if (orgId) fetchData();
    }, [orgId]);

    if (loading) {
        return (
            <div className="app-content p-4">
                <div className="container-fluid mt-2">
                    <div className="d-flex justify-content-center align-items-center loader-container">
                        <button className="btn btn-outline-secondary mt-3" type="button">
                            <span className="spinner-border spinner-border-sm align-middle me-2" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !organization) {
        return (
            <div className="app-content p-4">
                <div className="container-fluid mt-2">
                    <Link to="/organization" className="back-icon">
                        <i className="fa-solid fa-xl fa-circle-arrow-left"></i>
                    </Link>
                    <div className="alert alert-warning mt-3">{error || 'Registry not found.'}</div>
                </div>
            </div>
        );
    }

    const countryName = organization.countryRef?.countryName ?? organization.countryName ?? '';

    return (
        <div className="app-content p-4">
            <div className="container-fluid mt-2">
                <div className="text-start mb-4">
                    <Link to="/organization" className="back-icon">
                        <i className="fa-solid fa-xl fa-circle-arrow-left"></i>
                    </Link>
                </div>
                <div className="card custom-card create-user-card">
                    <div className="card-header justify-content-between">
                        <div className="card-title">Registry Details</div>
                    </div>
                    <div className="card-body">
                        <div className="row mb-4">
                            <label className="col-sm-3 col-form-label fw-medium">Registry Name</label>
                            <div className="col-sm-3 col-form-label text-dark">{organization.orgname || '–'}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <h6 className="col-sm-11 sub-section-heading">Primary Contact</h6>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Name</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.primconname || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Email</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.primconemail || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Phone No.</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.primconphone || '–'}</div>
                                </div>
                                <div className="row mt-2">
                                    <h6 className="col-sm-11 sub-section-heading">ISAKOS Member Contact</h6>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Name</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.secconname || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Email</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.secconemail || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Phone No.</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.secconphone || '–'}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <h6 className="col-sm-11 sub-section-heading">Registry Address</h6>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Address Line 1</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.address1 || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Address Line 2</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.address2 || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">City</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.city || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">State</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.state || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Country</label>
                                    <div className="col-sm-6 col-form-label text-dark">{countryName || '–'}</div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label text-muted">Postal Code</label>
                                    <div className="col-sm-6 col-form-label text-dark">{organization.postalcode ?? '–'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrganizationDetail;
